module.exports = __webpack_public_path__ + "static/media/logo.fc181fb2.png";